<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

				<em class="lt_text mgl_15">A/R Base Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="ar_base_date"/></span>

				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				<font color="red"><b>This report may take a while to load. Please wait after clicking Search.</b></font>
			</div>
		</div>

		<div v-if="searched" style="padding: 20px;">
			<table class="summary-tbl" id="summaryTable">
				<!-- Net Sales Section -->
				<tbody>
					<tr class="section-header">
						<td colspan="4">For Year Ended {{ to_date }}</td>
					</tr>
					<tr class="col-header">
						<td></td>
						<td>USA</td>
						<td>Foreign (Non-USA)</td>
						<td>TOTAL</td>
					</tr>
					<tr>
						<td class="row-label">Net Sales</td>
						<td class="al_right">{{ root.usa_net_sales | toCurrency }}</td>
						<td class="al_right">{{ root.foreign_net_sales | toCurrency }}</td>
						<td class="al_right total-val">{{ root.total_net_sales | toCurrency }}</td>
					</tr>
					<tr class="sub-header">
						<td></td>
						<td class="highlight">Customer Name</td>
						<td class="highlight">Amount</td>
						<td></td>
					</tr>
					<tr>
						<td class="row-label">The largest Net Sale</td>
						<td class="highlight al_center">{{ root.largest_net_sale_customer_code }}</td>
						<td class="highlight al_right">$ {{ root.largest_net_sale_amount | toCurrency }}</td>
						<td></td>
					</tr>
				</tbody>

				<!-- Spacer -->
				<tbody>
					<tr>
						<td colspan="4" class="spacer"></td>
					</tr>
				</tbody>

				<!-- A/R Section -->
				<tbody>
					<tr class="section-header">
						<td colspan="4">As of {{ ar_base_date }}</td>
					</tr>
					<tr class="col-header">
						<td></td>
						<td>USA</td>
						<td>Foreign (Non-USA)</td>
						<td>TOTAL</td>
					</tr>
					<tr>
						<td class="row-label">A/R</td>
						<td class="al_right">{{ root.usa_ar | toCurrency }}</td>
						<td class="al_right">{{ root.foreign_ar | toCurrency }}</td>
						<td class="al_right total-val">{{ root.total_ar | toCurrency }}</td>
					</tr>
					<tr class="sub-header">
						<td></td>
						<td class="highlight">Customer Name</td>
						<td class="highlight">Amount</td>
						<td></td>
					</tr>
					<tr>
						<td class="row-label">The largest A/R</td>
						<td class="highlight al_center">{{ root.largest_ar_customer_code }}</td>
						<td class="highlight al_right">$ {{ root.largest_ar_amount | toCurrency }}</td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="bottom_bt_box" v-if="searched">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="Excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiAnnualSalesArSummary, apiIndex } from '@/api/report/report';
import { apiGetReportTemplate, reportMrtUrl, objectToFormData, PrintType, Report } from '@/api/util';
import CustomDatePicker from '@/components/common/CustomDatePicker';
function yearStart() {
	return '01-01-' + new Date().getFullYear();
}
function yearEnd() {
	return '12-31-' + new Date().getFullYear();
}

export default {
	name: 'AnnualSalesArSummary',
	data: function() {
		return {
			from_date: yearStart(),
			to_date: yearEnd(),
			ar_base_date: yearEnd(),
			root: {},
			us_code: '',
			countries: [],
			searched: false,
		};
	},
	components: {
		CustomDatePicker,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
	},
	methods: {
		async selectData() {
			if (!this.us_code) {
				this.$toast.error('US country code not found.');
				return;
			}
			const paramObj = {
				from_date: this.from_date || '',
				to_date: this.to_date || '',
				ar_base_date: this.ar_base_date || '',
				us_code: this.us_code || '',
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiAnnualSalesArSummary(param);
			if (data.value) {
				this.root = data.value;
				this.searched = true;
			}
		},
		async reportPrint() {
			this.root.type = 'print';
			this.root.print_dt = this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss');
			const reportTemplate = await apiGetReportTemplate('AnnualSalesArSummary', reportMrtUrl('AnnualSalesArSummary'));
			const report = new Report(reportTemplate, this.root, 'AnnualSalesArSummary', PrintType.Normal);
			this.$store.commit('setReport', report);
		},
		async Excel() {
			this.root.type = 'excel';
			this.$store.commit('setLoading', true);
			const reportTemplate = await apiGetReportTemplate('AnnualSalesArSummary', reportMrtUrl('AnnualSalesArSummary'));
			let dataSet = new window.Stimulsoft.System.Data.DataSet();
			dataSet.readJson(this.root);
			reportTemplate.regData('', '', dataSet);
			reportTemplate.renderAsync(() => {
				const settings = new window.Stimulsoft.Report.Export.StiExcel2007ExportSettings();
				const service = new window.Stimulsoft.Report.Export.StiExcel2007ExportService();
				const stream = new window.Stimulsoft.System.IO.MemoryStream();
				service.exportToAsync(
					() => {
						const data = stream.toArray();
						const blob = new Blob([new Uint8Array(data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
						const link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.download = 'Sales and AR (US vs Foreign and the Largest).xlsx';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.$store.commit('setLoading', false);
					},
					reportTemplate,
					stream,
					settings,
				);
			});
		},
		async index() {
			const { data } = await apiIndex();
			this.countries = data.countryList || [];
			this.findUsCode();
		},
		findUsCode() {
			const us = this.countries.find(el => el.name === 'UNITED STATES' || el.name === 'USA' || el.name === 'US');
			if (us) this.us_code = us.code;
		},
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_annualSalesArSummary');
		this.$store.commit('setSubTitle', 'Report -> Annual Sales & AR Summary');
		this.index();
	},
};
</script>

<style scoped>
.summary-tbl {
	border-collapse: collapse;
	font-size: 13px;
	min-width: 700px;
}
.summary-tbl td {
	border: 1px solid #bbb;
	padding: 7px 12px;
}
.summary-tbl .section-header td {
	background: #f5f5f5;
	font-weight: bold;
	font-size: 13px;
	border-bottom: 2px solid #999;
}
.summary-tbl .col-header td {
	text-align: center;
	font-weight: bold;
	background: #fafafa;
}
.summary-tbl .col-header td:first-child {
	background: #fff;
}
.summary-tbl .row-label {
	font-weight: bold;
	padding-left: 20px;
}
.summary-tbl .highlight {
	background: #fff9c4;
	text-align: center;
	font-weight: bold;
}
.summary-tbl .sub-header td {
	font-weight: bold;
}
.summary-tbl .total-val {
	font-weight: bold;
}
.summary-tbl .spacer {
	border: none;
	height: 15px;
	background: #fff;
}
.summary-tbl .al_right {
	text-align: right;
}
.summary-tbl .al_center {
	text-align: center;
}
</style>
